import React from 'react';
import PropTypes from 'prop-types';

const IdentityQuestionsPropTypes = {
  identityQuestions: PropTypes.arrayOf(PropTypes.shape({
    score: PropTypes.number,
    source: PropTypes.string,
  })),
};

const IdentityQuestionsDefaultProps = {
  identityQuestions: null,
};

function IdentityQuestions(props) {
  const { identityQuestions: idQuestions } = props;
  const idQuestion = idQuestions && idQuestions.length ? idQuestions[0] : null;
  const wrapperClasses = idQuestion ? 'flex space' : null;

  return (
    <div>
      <p className="bold">Identity Questions</p>
      <div className={wrapperClasses}>
        {idQuestion ? (
          <>
            <p className="small-text bold header-top-4">{idQuestion.source}</p>
            <p className="small-text">
              {idQuestion.score}
              %
            </p>
          </>
        ) : (
          <p className="small-text light-grey"><i>No identity questions found</i></p>
        )}
      </div>
    </div>
  );
}
IdentityQuestions.propTypes = IdentityQuestionsPropTypes;
IdentityQuestions.defaultProps = IdentityQuestionsDefaultProps;

export default IdentityQuestions;
